import { useEffect } from 'react';

import { STATIC_CONSTANTS } from 'constants/static-constants';
import { useDocumentTitle } from 'hooks/document-title';
import { useQueryParams } from 'hooks/query-params';
import ReactGA from 'react-ga4';

import { Button, FormMessage } from 'components/FormComponents';

const RefereeError404 = () => {
  useDocumentTitle('Referee not found | Checkmate');
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;

  const [message] = useQueryParams(['message']);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '404 Referee not found',
    });
  }, []);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center p-8 relative gap-8">
      <div className="blob blob-1"></div>
      <div className="w-full md:w-1/2 lg:w-1/3 flex flex-col items-center justify-center gap-8 bg-neutral-1 rounded-3xl p-8 border border-neutral-4 z-10 shadow-2xl shadow-primary-4/20">
        <div
          className="rounded-3xl border border-neutral-4 w-full h-[350px] bg-cover bg-center bg-no-repeat mb-6"
          style={{ backgroundImage: 'url(/assets/images/reference-updated.svg)' }}></div>
        <div className="flex flex-col items-center justify-center gap-2">
          <h1 className="text-5xl font-bold text-neutral-7 text-center">
            No action needed from you
          </h1>
          <p className="text-neutral-6 text-2xl text-center">
            This reference request is no longer active as it has been {message || 'updated'}.
          </p>
        </div>
        <FormMessage
          type="Brand"
          message="Feel free to reach out to the candidate, or ask them to have their prospective employer resend the request."
          closeable={false}
          noMargin
        />
        <Button
          type="gradient"
          className="w-full"
          onClick={() => (window.location.href = `${STATIC_CONSTANTS.MARKETING_URL}`)}>
          Go to Checkmate
        </Button>
      </div>
      <span className="text-text-tertiary text-lg">
        For any further queries, please contact us at{' '}
        <a
          href={`mailto:${supportEmail}`}
          className="text-primary-4 hover:text-primary-5 transition-colors duration-200">
          {supportEmail}
        </a>
      </span>
    </div>
  );
};

export default RefereeError404;
